<template>
    <form id="TipoForm" @submit.prevent="cadastrarNovo" class="ajax_off">
        <div class="row justify-content-md-center">
            <div class="col col-lg-10">
                <div class="form-group">
                    <label
                        ><span v-if="edit_tipo && edit_tipo.id"
                            >Alterar nome do</span
                        ><span v-else>Cadastrar novo tipo de</span>
                        Alvará:</label
                    >

                    <input
                        type="text"
                        class="form-control"
                        maxlength="36"
                        v-model="tipo"
                        required
                    />
                    <span class="text-danger" v-if="tipo.length >= 36"
                        >*Você atingiu o limite máximo de caracteres!</span
                    >
                </div>

                <b-form-group
                    label="Escolha uma das cores diponíveis:"
                    v-slot="{ ariaDescribedby }"
                >
                    <b-form-radio
                        inline
                        v-model="selected_color"
                        :aria-describedby="ariaDescribedby"
                        v-for="color in filterColors"
                        :key="color.id"
                        :value="color.id"
                        ><span
                            class="btn"
                            :style="`background-color:${color.bg_color}`"
                        ></span>
                    </b-form-radio>
                </b-form-group>
            </div>
        </div>
    </form>
</template>
<script>
export default {
    props: {
        edit_tipo: null,
        colors: Array,
        tipos: Array
    },
    data() {
        return {
            tipo: '',
            selected_color: false,
            current_tipos: []
        };
    },
    computed: {
        filterColors() {
            return this.colors.filter(
                color =>
                    !this.current_tipos.some(tipo => tipo.color_id == color.id)
            );
        }
    },
    created() {
        if (this.edit_tipo)
            this.selected_color = this.edit_tipo.color_id;


        if (this.tipos.lenght)
            this.current_tipos = this.tipos.filter(
                tipo => tipo.id != this.edit_tipo.id
            );

        if (this.edit_tipo && this.edit_tipo.tipo)
            this.tipo = this.edit_tipo.tipo;

    },
    methods: {
        async cadastrarNovo() {
            if (!this.selected_color)
                this.selected_color = this.edit_tipo.color_id;

            const result = await this.$api.post("alvaras/tipo", {
                edit_tipo: this.edit_tipo,
                tipo: this.tipo,
                color_id: this.selected_color
            });
            this.tipo = '';

            this.$emit("getTipos");
            this.$bvModal.hide("TipoFormModal");
        }
    }
};
</script>
